/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TermsOfServiceLawFirmPageMeta from "./TermsOfServiceLawFirmPageMeta";
import Container from "@/src/components/Container/Container";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import TermsOfServiceLawFirm from "@/src/components/TermsOfService/TermsOfServiceLawFirm/TermsOfServiceLawFirm";

const TermsOfServiceLawFirmPage = () => {
  return (
    <LayoutPublicRoutes>
      <TermsOfServiceLawFirmPageMeta />
      <Container showVerticalPadding={false}>
        <TermsOfServiceLawFirm />
      </Container>
    </LayoutPublicRoutes>
  );
};

export default TermsOfServiceLawFirmPage;
